import * as yup from "yup";

let statusValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  color: yup.string().required("Charge is required"),
  sms_content: yup.string().optional().nullable(),
});
export { statusValidationForm };
